export default {
  // 国际园数据填报
  internationManage: {
    // 添加
    add: "dataSubForm_internationManage_add",
    // 编辑
    edit: "dataSubForm_internationManage_edit",
    // 删除
    delete: "dataSubForm_internationManage_delete",
    // 切换状态
    change: "dataSubForm_internationManage_change",
  },
}